import { render, staticRenderFns } from "./ShowColumn.vue?vue&type=template&id=2d7a0c93&lang=pug&"
import script from "./ShowColumn.vue?vue&type=script&lang=js&"
export * from "./ShowColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports